<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :btnRefreshVisible="true" :btnNewVisible="false" :linkConfigurazioni="linkConfigurazione" @refresh="onRefresh" :showModalLoading="showModalLoading">
        <template #toolbar>
            <b-button class="button-new" size="sm" variant="success btn-toolbar float-sm-right sa-margin-right" @click="onNew">
                <b-icon icon="plus"></b-icon>
                {{ $t("global.lblBtnNew") }}
            </b-button>
        </template>
        <template #table-filter>
            <div class="sa-list-component-header" style="padding-top: 5px">
                <div class="sa-page-search-component">
                    <b-form style="width: 100%" @submit.prevent="onSubmit">
                        <b-row class="sa-form-btn-filter">
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Nome:</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroModalitaSomministrazione.nome" placeholder="Inserisci modalità.." />
                                </div>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Tipologia:</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <select class="sa-page-search-component-input" v-model="filtroModalitaSomministrazione.tipologia">
                                        <option v-for="opt in tipologiaOptions" :key="opt.value" :value="opt.value">
                                            {{ opt.text }}
                                        </option>
                                    </select>

                                    <button class="sa-page-search-component-btn-search" title="Search">
                                        <i class="fas fa-search"></i>
                                    </button>
                                    <button class="sa-page-search-component-btn-reset" @click="resetFiltroModalitaSomministrazione" type="button"><i class="fas fa-trash"></i></button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </div>
        </template>
        <template slot="table-body">
            <rsa-configurazione-modalita-somministrazione-list-component ref="ConfigurazioneModalitaSomministrazioneListComponent" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData"></rsa-configurazione-modalita-somministrazione-list-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneModalitaSomministrazioneListComponent from "../components/RsaConfigurazioneModalitaSomministrazioneListComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneModalitaSomministrazioneListComponent },

    data() {
        return {
            linkConfigurazione: "/configurazioni",
            pathResource: "/rsapazienteprescrizionimodalitasomministrazione",
            showModalLoading: false,
            filtroModalitaSomministrazione: {
                nome: null,
                tipologia: null,
            },
            tipologiaOptions: [
                { text: "TUTTE", value: null },
                { text: "SOLUZIONE", value: "SOLUZIONE" },
                { text: "FARMACO", value: "FARMACO" },
                { text: "ELASTOMERO", value: "ELASTOMERO" },
            ],
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        me.showModalLoading = true;
        let filtroModalitaSomministrazione = sessionStorage.getItem("filtroModalitaSomministrazione");
        if (filtroModalitaSomministrazione) {
            me.filtroModalitaSomministrazione = JSON.parse(filtroModalitaSomministrazione);
        }
        me.loadData(me.filtroModalitaSomministrazione);
    },
    methods: {
        loadData(filtro) {
            let me = this;
            me.onBeforeLoadData();
            me.$refs.ConfigurazioneModalitaSomministrazioneListComponent.loadData(filtro);
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroModalitaSomministrazione = sessionStorage.getItem("filtroModalitaSomministrazione");
            if (filtroModalitaSomministrazione) {
                me.filtroModalitaSomministrazione = JSON.parse(filtroModalitaSomministrazione);
            }
            me.loadData(me.filtroModalitaSomministrazione);
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        resetFiltroModalitaSomministrazione() {
            let me = this;
            me.filtroModalitaSomministrazione = {
                nome: null,
                tipologia: null,
            };
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroModalitaSomministrazione", JSON.stringify(me.filtroModalitaSomministrazione));
            this.$refs.ConfigurazioneModalitaSomministrazioneListComponent.loadData();
        },
        onNew() {
            this.$refs.ConfigurazioneModalitaSomministrazioneListComponent.onEdit({ id: "-1", nome: "", descrizione: "", tipologia: null, ordering: "" });
        },
        onSubmit() {
            let me = this;
            me.showModalLoading = true;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroModalitaSomministrazione", JSON.stringify(me.filtroModalitaSomministrazione));
            me.$refs.ConfigurazioneModalitaSomministrazioneListComponent.loadData(me.filtroModalitaSomministrazione);
        },
    },
};
</script>
<style scoped>
.button-new {
    border: 1px solid #218838;
}

.sa-form-btn-filter > .col-md-6:last-child {
    margin-top: 0px;
}

.sa-page-search-component-input::-ms-expand {
    display: none;
}

.sa-page-search-component-input {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: 9px;
}
</style>
